// Event metadata & visual configuration for Wrocław 2026
export const META = {
  slug: "wroclaw-2026",
  title: "Business Conf · Wrocław",
  domain: "wrocon.voxianet.com",
  contactWebhookUrl: process.env.REACT_APP_N8N_CONTACT_WEBHOOK || "https://automation.voxianet.com/webhook/wrocon-contact",
  // Turnstile — kontakt i płatność to OSOBNE configi (action/site key), zgodnie z manifestem.
  turnstileAction: "wrocon_contact",
  paymentTurnstileAction: "wrocon_registration",
  expectedHostname: "wrocon.voxianet.com",
};

// Faza 2B (2.1): TICKETS niesie WYŁĄCZNIE prezentację (ikona, badge, highlight, soldOut).
// Cena i waluta pochodzą z backendu (/api/tickets z manifestu) — patrz lib/useCatalog.js.
// Kolejność wpisów definiuje kolejność renderu kart.
export const TICKETS = [
  { key: "standard", icon: "🎟", highlight: false, soldOut: false },
  { key: "standard_duo", icon: "👥", highlight: true, badgeKey: "popular", soldOut: false },
  { key: "speaker_10", icon: "🎤", highlight: false, soldOut: false },
  { key: "speaker_30", icon: "✨", highlight: true, badgeKey: "premium", soldOut: false },
  { key: "afterparty", icon: "🎉", highlight: false, soldOut: false },
];

export const SPEAKER_PHOTOS = [
  "/events/wroclaw-2026/speakers/marina-fedak.JPG",
  "/events/wroclaw-2026/speakers/roxolana-ivroxe.jpg",
  "/events/wroclaw-2026/speakers/anastasiia-kasian.jpg",
  "/events/wroclaw-2026/speakers/anna-khoroshilova.jpg",
  "/events/wroclaw-2026/speakers/viktor-bartak.jpg",
  "/events/wroclaw-2026/speakers/tatiana-alekseeva.jpg",
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1675716921224-e087a0cca69a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1515168833906-d2a3b82b302a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/8761636/pexels-photo-8761636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=85";

export const PARTNERS = ["FORVIA", "NEXUS", "ATELIER", "ORION", "STELLAR", "MERIDIAN", "VERTEX", "AURUM"];
